const ACTION = {
  ITEM_CLICK: 'item_click',
  DOWNLOAD_CLICK: 'download_click',
  LOGIN: 'login_click',
  TTM_SEARCH: 'ttm_search_click',
  CART_CLICK: 'cart_click',
  GOTO_CHECKOUT_CLICK: 'goto_checkout_click',
  WISHLIST_CLICK: 'wishlist_click',
  GO_HELP_CLICK: 'go_help_click',
  PAYMENT_SUCCESS: 'payment_success',
  HOW_TO_USE_CLICK: 'how_to_use_click',
  CATEGORY_CLICK: 'category_click',
  // v1.1 added
  SEND_MESSAGE: 'send_message',
  CLICK_JOIN_CHAT: 'click_join_chat',
  CLICK_JOIN_GROUPCHAT: 'click_join_groupchat',
  CLICK_JOIN_GAME: 'click_join_game',
  CLICK_PLAY_GAME: 'click_play_game',
  CLICK_GAMEROOM: 'click_gameroom',
  CLICK_SUBMIT_ANSWER: 'click_submit_answer',
  CLICK_GO_ENDING: 'click_go_ending',
  CLICK_GENERATE_CHARACTER: 'click_generate_character',
  CLICK_APPLY_CHARACTER: 'click_apply_character',
  CLICK_DARTSTORE: 'click_dartstore',
  CLICK_CLAIM_REWARD: 'click_claim_reward',
  CLICK_BUY_DART: 'click_buy_dart',
} as const;

const CATEGORY = {
  DOWNLOAD: 'download',
  ECOMMERCE: 'eCommerce',
  ACCESS: 'access',
  TTM: 'ttm',
  CART: 'cart',
  CHECKOUT: 'checkout',
  WISHLIST: 'wishlist',
  HELP: 'help',
  PAYMENT: 'payment',
  // v1.1 added
  MESSAGE: 'message',
  CHAT: 'chat',
  GROUP_CHAT: 'group chat',
  GAME: 'game',
  CHARACTER: 'character',
  STORE: 'store',
} as const;

export const GA = { ACTION, CATEGORY } as const;

/* 
ex)
  GAEvent(email, GA.ACTION.WISHLIST_CLICK, {
    asset_title: title,
    asset_value: discountPrice,
    category: GA.CATEGORY.ECOMMERCE,
    asset_id: id,
  });

*/
